import type { Genie2ReportingMode } from '~/utils/analyticsReportingMode';
import {
  staffConfigModeQueryKeyPart,
  staffConfigModeQueryParams,
} from '~/hooks/analyticsStatAccess/statAccessQueryScope';

export type AnalyticsMode = 'client' | 'authoring';

export function analyticsQueryParams(
  mode: AnalyticsMode,
  authoringStatSet?: Genie2ReportingMode | null,
): Record<string, string> {
  if (mode !== 'authoring') {
    return {};
  }
  return (
    staffConfigModeQueryParams(authoringStatSet, { mode: 'authoring' }) ?? { mode: 'authoring' }
  );
}

export function analyticsAuthoringQueryKeyPart(
  mode: AnalyticsMode,
  authoringStatSet?: Genie2ReportingMode | null,
): Genie2ReportingMode | null {
  return mode === 'authoring' ? staffConfigModeQueryKeyPart(authoringStatSet) : null;
}

export function statMetadataModeFromAnalyticsMode(mode: AnalyticsMode): 'default' | 'authoring' {
  return mode === 'authoring' ? 'authoring' : 'default';
}
